@if (role() === "admin") {
  <div class="absolute top-28 left-6 flex items-center justify-center gap-4">
    <!-- @if (
      status().toLowerCase() !== "packaged" &&
      status().toLowerCase() !== "partially_packaged" &&
      status().toLowerCase() !== "approved" &&
      status().toLowerCase() !== "rejected" &&
      status().toLowerCase() !== "shipped" &&
      status().toLowerCase() !== "delivered" &&
      status().toLowerCase() !== "partially_delivered" &&
      status().toLowerCase() !== "undelivered"
    ) {
      <app-submit-button>إلغاء</app-submit-button>
      <app-submit-button>تعديل</app-submit-button>
    } -->
    @if (
      status().toLowerCase() === "pending" ||
      status().toLowerCase() === "printed" ||
      status().toLowerCase() === "updated" ||
      status().toLowerCase() === "partially_packaged" ||
      status().toLowerCase() === "packaged" ||
      status().toLowerCase() === "rejected" ||
      status().toLowerCase() === "approved"
    ) {
      <app-submit-button (click)="onOpenCancel()">
        {{ isArabic() ? "إلغاء الطلب" : "Cancel Order" }}
      </app-submit-button>
      <app-submit-button>{{ isArabic() ? "تعديل الطلب" : "Edit Order" }}</app-submit-button>
    }
    @if (status().toLowerCase() === "packaged") {
      <app-submit-button *hasScope="SCOPES.ORDERS.CONFIRM_REVIEW" (click)="onOpenReject()">
        <span>{{ isArabic() ? " رفض المراجعة" : "Reject Review" }}</span>
      </app-submit-button>
    }
    @if (status().toLowerCase() !== "printed") {
      @if (status().toLowerCase() === "pending" || status().toLowerCase() === "updated") {
        <app-submit-button *hasScope="SCOPES.ORDERS.PRINT" (click)="handleActionClick()" type="primary">
          <span>{{ isArabic() ? "طباعة" : "Print" }}</span>
        </app-submit-button>
      }
      @if (status().toLowerCase() === "packaged") {
        <app-submit-button *hasScope="SCOPES.ORDERS.CONFIRM_REVIEW" (click)="handleActionClick()" type="primary">
          <span>{{ isArabic() ? "تأكيد المراجعة" : "Confirm Review" }}</span>
        </app-submit-button>
      }
      @if (status().toLowerCase() === "approved") {
        <app-submit-button *hasScope="SCOPES.ORDERS.SHIP" (click)="handleActionClick()" type="primary">
          <span>{{ isArabic() ? " تأكيد الشحن" : "Confirm Shipment" }}</span>
        </app-submit-button>
      }
      @if (status().toLowerCase() === "rejected") {
        <app-submit-button *hasScope="SCOPES.ORDERS.REPACKAGE" (click)="onOpenRepackage()" type="primary">
          <span>{{ isArabic() ? "إعادة التعبئة" : "Repackage" }}</span>
        </app-submit-button>
      }
      @if (status().toLowerCase() === "shipped") {
        <app-submit-button *hasScope="SCOPES.ORDERS.PRINT" (click)="handleActionClick('partially')">
          <span>تسليم جزئي</span>
        </app-submit-button>
        @if (canUndeliver()) {
          <app-submit-button *hasScope="SCOPES.ORDERS.UNDELIVER" (click)="handleActionClick('undeliver')">
            {{ isArabic() ? "إلغاء التسليم" : "Undeliver Order" }}
          </app-submit-button>
        }
        <app-submit-button *hasScope="SCOPES.ORDERS.DELIVER" (click)="handleActionClick('deliver')">
          <span>تسليم</span>
        </app-submit-button>
      }
      @if (canHandleShortages()) {
        <app-submit-button
          *hasScope="SCOPES.ORDERS.CONFIRM_PACKAGE"
          (click)="onOpenConfirmPackage()"
          [disabled]="!allShortagesHandled()"
          type="primary">
          <span>{{ isArabic() ? "تأكيد التعبئة" : "Confirm Package" }}</span>
        </app-submit-button>
      }
      @if (canShowCollectCash()) {
        <app-submit-button *hasScope="SCOPES.ORDERS.COLLECT_CASH" (click)="onOpenCollectCash()" type="primary">
          <span i18n="@@collectCashBtn">{{ isArabic() ? "تحصيل النقدية" : "Collect Cash" }}</span>
        </app-submit-button>
      }

      @if (status().toLowerCase() === "undelivered") {
        <app-submit-button (click)="onReceiveReturnedProducts()" type="primary">
          <span>{{ isArabic() ? "استلام المنتجات المرتجعة" : "Return Product Received" }}</span>
        </app-submit-button>
      }

      @if (
        (status().toLowerCase() === "partially_delivered" || status().toLowerCase() === "partially-delivered") &&
        !receiveReturnedProductsView()
      ) {
        <app-submit-button (click)="onReceiveReturnedProductsPartially()" type="primary">
          <span>{{ isArabic() ? "استلام المنتجات المرتجعة" : "Return Product Received" }}</span>
        </app-submit-button>
      }
    }
  </div>
}

<div class="flex items-center gap-6">
  <h2 class="textPrimary ltr text-3xl font-semibold">#{{ orderData()?.id }}</h2>
  <span class="inline-flex items-center rounded-full px-4 py-1 text-xs font-medium" [ngClass]="statusStyle()">
    {{ statusContent() }}
    <!-- {{ isArabic() ? orderData()?.status?.titleAr : orderData()?.status?.titleEn }} -->
  </span>
</div>
@if (!error() && !loading() && rejectionReason(); as reason) {
  <div class="mt-4 flex flex-col gap-3 rounded-2xl border-2 border-red-500 bg-white px-5 py-4">
    <div class="flex items-center gap-2">
      <app-reject-highlight />
      <h4 class="text-[15px] font-medium text-gray-900">
        {{ isArabic() ? "سبب الرفض" : "Rejection Reason" }}
      </h4>
    </div>

    <p class="text-[13px] text-gray-900">{{ reason }}</p>
  </div>
}

<div class="grid grid-cols-1 gap-6">
  <div class="flex flex-col gap-4 lg:col-span-2">
    <div class="rounded-xl p-5">
      <div class="relative">
        @if (loading()) {
          <div class="absolute inset-0 z-10 flex items-center justify-center rounded bg-white/60">
            <app-loading />
          </div>
        }
        @if (error()) {
          <app-error-data [title]="error()" />
        }

        @if (!error() && !loading()) {
          <div class="w-full gap-6 rounded-xl bg-white px-4 py-3 shadow-xl">
            <h3 class="mb-4">
              {{
                isArabic()
                  ? "تفاصيل الطلب" + " " + "(" + orderData()?.totalQuantity + ")"
                  : "Order Details" + " " + "(" + orderData()?.totalQuantity + ")"
              }}
            </h3>
            <div class="flex items-start gap-4">
              <div class="flex-2/3">
                @for (item of visibleItems(); track item.id) {
                  <div class="flex w-full flex-col gap-4 border-b border-gray-50 pb-5 last:border-0 last:pb-0">
                    <div class="flex w-full flex-2/3 flex-col gap-4">
                      @if (item.product) {
                        <app-order-product-item
                          [isProductOffer]="$any(item)?.discountOffer"
                          [productTitle]="isArabic() ? $any(item)?.product.titleAr : $any(item)?.product.titleEn"
                          [mfgDate]="$any(item)?.product.mfgDate"
                          [expDate]="$any(item)?.product.expDate"
                          [businessPrice]="$any(item)?.product.storePrice"
                          [peoplePrice]="$any(item)?.product.peoplePrice.toString()"
                          [totalBusinessPrice]="+$any(item)?.totalStorePrice"
                          [quantity]="item?.quantity"
                          [batchNumber]="$any(item)?.product.batchNumber"
                          [profileImageFid]="$any(item)?.product.profileImageFid"
                          [isPrinted]="isOrderPrinted()"
                          [packageQuantity]="getPackageDataFor(item.id.toString()).packageQuantity"
                          [notPackageRows]="getPackageDataFor(item.id.toString()).notPackageRows"
                          (packageClicked)="openPackagePopup(item)"
                          [isPartiallyPackaged]="canHandleShortages()"
                          [confirmAction]="getConfirmActionFor(item.id.toString())"
                          [showOnlyPackaged]="showOnlyPackagedFor(item.id.toString())"
                          (confirmShortageClicked)="openConfirmShortage(item.id.toString(), 'product')"
                          (dropShortageClicked)="openDropFromOrder(item.id.toString(), 'product')"
                          [role]="role()"
                          [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                      }

                      @if (item.type === "OFFER_BUY_X_GET_Y") {
                        @if (getConfirmActionFor(item.id.toString()) === "CONVERT") {
                          @for (
                            converted of convertedProductsFor(item.id.toString());
                            track converted.product?.id ?? $index
                          ) {
                            <app-order-product-item
                              [productTitle]="isArabic() ? converted.product.titleAr : converted.product.titleEn"
                              [mfgDate]="converted.product.mfgDate"
                              [expDate]="converted.product.expDate"
                              [businessPrice]="converted.product.storePrice"
                              [peoplePrice]="converted.product.peoplePrice?.toString()"
                              [totalBusinessPrice]="+converted.product.storePrice * converted.quantity"
                              [quantity]="converted.quantity"
                              [batchNumber]="converted.product.batchNumber"
                              [profileImageFid]="converted.product.profileImageFid"
                              [isPrinted]="isOrderPrinted()"
                              [isPartiallyPackaged]="false"
                              [role]="role()"
                              [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                          } @empty {
                            <p
                              class="rounded-lg border border-gray-200 bg-gray-50 py-6 text-center text-[13px] text-gray-400">
                              {{ isArabic() ? "لا توجد منتجات محولة" : "No converted products" }}
                            </p>
                          }
                        } @else {
                          <app-order-offer-item
                            [productTitle]="
                              isArabic() ? $any(item)?.bxGyOffer?.titleAr : $any(item)?.bxGyOffer?.titleEn
                            "
                            [buyQuantity]="$any(item)?.bxGyOffer?.buyQuantity"
                            [getQuantity]="$any(item)?.bxGyOffer?.getQuantity"
                            [products]="$any(item)?.products"
                            [totalBusinessPrice]="$any(item)?.totalStorePrice?.toFixed(2)"
                            [quantity]="$any(item)?.quantity"
                            [profileImageFid]="
                              $any(item)?.bxGyOffer?.profileImageFid ?? $any(item)?.offer?.profileImageFids?.[0]
                            "
                            [isPrinted]="isOrderPrinted()"
                            [packageState]="packageState()"
                            [offerItemId]="item.id"
                            (packageClicked)="openProductPackagePopup($event, item.id.toString(), 'offer')"
                            [isPartiallyPackaged]="canHandleShortages()"
                            [offerNotPackage]="$any(item)?.bxGyOffer?.notPackage ?? $any(item)?.offer?.notPackage ?? []"
                            [packageQuantity]="getPackageDataFor(item.id.toString()).packageQuantity"
                            [notPackageRows]="getPackageDataFor(item.id.toString()).notPackageRows"
                            (convertClicked)="openConvertOffer(item.id.toString())"
                            (dropAllClicked)="openDropAllOffer(item.id.toString())"
                            [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                        }
                      }

                      @if (item.type === "BUNDLE") {
                        @if (getConfirmActionFor(item.id.toString()) === "CONVERT") {
                          @for (
                            converted of convertedProductsFor(item.id.toString());
                            track converted.product?.id ?? $index
                          ) {
                            <app-order-product-item
                              [productTitle]="isArabic() ? converted.product.titleAr : converted.product.titleEn"
                              [mfgDate]="converted.product.mfgDate"
                              [expDate]="converted.product.expDate"
                              [businessPrice]="converted.product.storePrice"
                              [peoplePrice]="converted.product.peoplePrice?.toString()"
                              [totalBusinessPrice]="+converted.product.storePrice * converted.quantity"
                              [quantity]="converted.quantity"
                              [batchNumber]="converted.product.batchNumber"
                              [profileImageFid]="converted.product.profileImageFid"
                              [isPrinted]="isOrderPrinted()"
                              [isPartiallyPackaged]="false"
                              [role]="role()"
                              [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                          } @empty {
                            <p
                              class="rounded-lg border border-gray-200 bg-gray-50 py-6 text-center text-[13px] text-gray-400">
                              {{ isArabic() ? "لا توجد منتجات محولة" : "No converted products" }}
                            </p>
                          }
                        } @else {
                          <app-order-bundle-item
                            [productTitle]="isArabic() ? $any(item).bundle.titleAr : $any(item).bundle.titleEn"
                            [products]="$any(item).products"
                            [totalBusinessPrice]="$any(item)?.totalStorePrice?.toFixed(2)"
                            [quantity]="item.quantity"
                            [profileImageFid]="$any(item).bundle.profileImageFid"
                            [totalBusinessPriceBeforeDiscount]="$any(item).bundle.totalPharmacyPriceBeforeDiscount"
                            [bundleDiscountType]="$any(item).bundle.discountType"
                            [bundleDiscountValue]="$any(item).bundle.discountValue"
                            [isPrinted]="isOrderPrinted()"
                            [packageQuantity]="getPackageDataFor(item.id.toString()).packageQuantity"
                            [notPackageRows]="getPackageDataFor(item.id.toString()).notPackageRows"
                            [isPartiallyPackaged]="canHandleShortages()"
                            [confirmAction]="getConfirmActionFor(item.id.toString())"
                            [showOnlyPackaged]="showOnlyPackagedFor(item.id.toString())"
                            (convertClicked)="openConvertOffer(item.id.toString())"
                            (dropAllClicked)="openDropAllOffer(item.id.toString())"
                            (productPackageClicked)="openProductPackagePopup($event, item.id.toString(), 'bundle')"
                            [packageState]="packageState()"
                            [bundleItemId]="item.id"
                            [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                        }
                      }
                    </div>
                  </div>
                } @empty {
                  <app-error-data [title]="isArabic() ? 'لا يوجد بيانات' : 'No Data'" />
                }
              </div>

              <div class="flex-1/3">
                <app-order-summary-card
                  [orderData]="orderData()"
                  [invoiceNo]="orderData()?.invoiceNo"
                  [totalQuantity]="orderData()?.totalQuantity"
                  [totalPharmacyPrice]="+(orderData()?.totalBusinessPrice ?? 0)"
                  [totalPeoplePrice]="totalPeoplePrice()"
                  [placedOn]="
                    isArabic()
                      ? orderData()?.deliveryAddress?.region?.titleAr +
                        ' ' +
                        orderData()?.deliveryAddress?.city?.titleAr +
                        ' ' +
                        orderData()?.deliveryAddress?.governorate?.titleAr +
                        ' '
                      : orderData()?.deliveryAddress?.region?.titleEn +
                        ' ' +
                        orderData()?.deliveryAddress?.city?.titleEn +
                        ' ' +
                        orderData()?.deliveryAddress?.governorate?.titleEn
                  "
                  [deliveryMan]="orderData()?.distributor?.fullName"
                  [total]="+(orderData()?.totalBusinessPrice ?? 0)"
                  [expectedDeliveryDate]="orderData()?.expectedDeliveryDate" />

                @if (isOrderPrinted()) {
                  <div class="mt-4 flex flex-col gap-2">
                    @if (errResetAction()) {
                      <p class="text-[12px] font-medium text-red-500">{{ errResetAction() }}</p>
                    }
                    <div class="grid grid-cols-2 gap-2">
                      <button
                        *hasScope="SCOPES.ORDERS.RESET_PACKAGE"
                        (click)="onOpenResetPackage()"
                        [disabled]="resettingPackage()"
                        class="cursor-pointer rounded-lg border border-gray-300 py-2.5 text-[13px] font-bold text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50">
                        {{ isArabic() ? "مسح" : "Clear" }}
                      </button>
                      <button
                        *hasScope="SCOPES.ORDERS.SUBMIT_PACKAGE"
                        (click)="onOpenSubmitPackage()"
                        [disabled]="!allItemsProcessed()"
                        class="bgTabsColor hover-bg-primary-hover cursor-pointer rounded-lg py-2.5 text-[13px] font-bold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-40">
                        {{ isArabic() ? "تأكيد التعبئة" : "Submit Package" }}
                      </button>
                    </div>
                  </div>
                }
                @if (receiveReturnedProductsView()) {
                  <div class="mt-4 flex flex-col gap-2">
                    @if (errResetAction()) {
                      <p class="text-[12px] font-medium text-red-500">{{ errResetAction() }}</p>
                    }
                    <div class="grid grid-cols-2 gap-2">
                      <button
                        (click)="onCancelReceiveReturnedProductsPartially()"
                        class="cursor-pointer rounded-lg border border-gray-300 py-2.5 text-[13px] font-bold text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50">
                        {{ isArabic() ? "إلغاء" : "Cancel" }}
                      </button>
                      <button
                        (click)="onOpenSubmitPackage()"
                        [disabled]="!allItemsProcessed()"
                        class="bgTabsColor hover-bg-primary-hover cursor-pointer rounded-lg py-2.5 text-[13px] font-bold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-40">
                        {{ isArabic() ? "تأكيد الإرجاع" : "Submit Returns" }}
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

@if (isPrintPopup()) {
  <app-order-action-popup
    #printPopup
    (submit)="onPrint(printPopup.comment())"
    [title]="isArabic() ? 'طباعة' : 'print'"
    [description]="isArabic() ? 'هل أنت متأكد من طباعة هذا الطلب؟' : 'Are you sure you want to print this order?'"
    (closePopup)="onClosePopup()"
    [loading]="printing()"
    [err]="errPrintAction()"
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
}
@if (reviewalApprovedPopup()) {
  <app-order-action-popup
    #reviewPopup
    [loading]="repackaging()"
    [err]="errRepackageAction()"
    (submit)="onReviewalApproved(reviewPopup.comment())"
    [title]="isArabic() ? 'قبول مراجعة الطلب' : 'Reviewal Approve'"
    (closePopup)="onCloseReviewalApprove()"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من تأكيد مراجعة هذا الطلب؟'
        : 'Are you sure you want to confirm the review for this order?'
    "
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
}

@if (rejectReview()) {
  <app-order-action-popup
    [optionData]="optionData()"
    type="detailed"
    label="تعليق"
    (submit)="onReject($event)"
    [title]="isArabic() ? 'رفض مراجعة الطلب' : 'Reviewal Reject'"
    (closePopup)="onCloseReject()"
    [description]="isArabic() ? 'لماذا تريد رفض مراجعة الطلب' : 'Why are you rejecting this order'"
    [submitBtnContent]="isArabic() ? 'رفض ' : 'Reject'"
    [detailedLabel]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
    [optionOne]="isArabic() ? 'حدد السبب لرفض هذا الطلب' : 'select the reason for rejecting this order'" />
}
@if (openRepackagePopup()) {
  <app-order-action-popup
    #repackagePopup
    [loading]="repackaging()"
    [err]="errRepackageAction()"
    [title]="isArabic() ? 'إعادة تعبئة الطلب' : 'Repackage'"
    (closePopup)="onCloseRepackage()"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من إعادة تعبئة هذا الطلب وإرساله للمراجعة مرة أخرى؟'
        : 'Are you sure you want to repackage this order and send it back for review?'
    "
    [submitBtnContent]="isArabic() ? 'تأكيد ' : 'Confirm'"
    (submit)="onRepackage(repackagePopup.comment())" />
}

@if (openPackage() && selectedPackageItem()) {
  @let pkgKey = selectedPackageItem()!.storeKey ?? selectedPackageItem()!.id;
  @let currentPkgData = getPackageDataFor(pkgKey);
  <app-item-status-popup
    [itemId]="selectedPackageItem()!.id"
    [storeKey]="selectedPackageItem()!.storeKey ?? null"
    [productTitleEn]="selectedPackageItem()!.titleEn"
    [productTitleAr]="selectedPackageItem()!.titleAr"
    [orderedQuantity]="+selectedPackageItem()!.quantity"
    [initialPackageQuantity]="currentPkgData?.packageQuantity"
    [initialNotPackageRows]="currentPkgData.notPackageRows"
    [itemType]="selectedPackageItem()!.type"
    mode="package"
    (closed)="openPackage.set(false)"
    (submitted)="onSubmitted()" />
}

@if (submitPackagePopup()) {
  <app-order-action-popup
    #submitPkgPopup
    [loading]="submitingPackage()"
    [err]="errSubmitAction()"
    [title]="isArabic() ? 'تأكيد تعبئة الطلب' : 'Submit Package'"
    (closePopup)="onCloseSubmitPackage()"
    [description]="isArabic() ? 'تأكيد تعبئة الطلب' : 'Submit Package'"
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Submit'"
    (submit)="onSubmitPackage(submitPkgPopup.comment())" />
}

@if (resetPackagePopup()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="isArabic() ? 'إعادة تعيين التعبئة' : 'Reset Package'"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من إعادة تعيين تفاصيل التعبئة لهذا الطلب؟'
        : 'Are you sure you want to reset package details for this order?'
    "
    [confirmContent]="isArabic() ? 'إعادة تعيين' : 'Reset'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    [isLoading]="resettingPackage()"
    [error]="errResetAction()"
    (onCancel)="onCloseResetPackage()"
    (onSubmit)="onResetPackage()"></app-confirmation-dialog>
}
@if (isShipPopup()) {
  <app-order-action-popup
    #shipPopup
    [loading]="shipping()"
    [optionData]="optionData()"
    label="تعليق"
    (submit)="onShipOrder(shipPopup.comment())"
    [title]="isArabic() ? 'شحن الطلب' : 'Ship Order'"
    (closePopup)="onCloseShipPopup()"
    [err]="errorShip()"
    [description]="isArabic() ? 'هل أنت متأكد من شحن الطلب ؟' : 'Are you sure you want to ship this order ?'"
    [submitBtnContent]="isArabic() ? 'شحن ' : 'Ship'"
    [detailedLabel]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
    [optionOne]="isArabic() ? 'حدد السبب لشحن هذا الطلب' : 'select the reason for shipping this order'" />
}

@if (isCollectCashPopup()) {
  <app-collect-cash-popup
    [expectedAmount]="orderData()?.amountCollected ?? 0"
    [loading]="collectingCash()"
    [err]="errCollectCash()"
    (submit)="onConfirmCollectCash($event)"
    (closePopup)="onCloseCollectCash()" />
}

@if (confirmPackagePopup()) {
  <app-order-action-popup
    #confirmPkgPopup
    [loading]="confirmingPackage()"
    [err]="errConfirmAction()"
    [title]="isArabic() ? 'تأكيد التعبئة' : 'Confirm Package'"
    (closePopup)="onCloseConfirmPackage()"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من تأكيد تعبئة هذا الطلب؟'
        : 'Are you sure you want to confirm the package for this order?'
    "
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'"
    (submit)="onConfirmPackage(confirmPkgPopup.comment())" />
}

@if (isConfirmProductPopupOpen() && selectedItemData()) {
  <app-confirm-product-popup
    [data]="selectedItemData()!"
    [itemType]="selectedItemType()"
    (closed)="onCloseConfirmShortage()"
    (confirmed)="onCloseConfirmShortage()" />
}

@if (isDropOrderPopupOpen()) {
  <app-drop-from-order-confirm
    [itemId]="selectedItemId()"
    [itemType]="selectedItemType()"
    (closed)="onCloseDropFromOrder()"
    (dropped)="onCloseDropFromOrder()" />
}

@if (isConvertProductsPopupOpen() && selectedOfferData()) {
  <app-convert-to-products-popup
    [data]="selectedOfferData()!"
    [packageState]="packageState()"
    [isPrinted]="isOrderPrinted()"
    [isPartiallyPackaged]="isOrderPartiallyPackaged()"
    (closed)="onCloseConvertOffer()"
    (confirmed)="onCloseConvertOffer()" />
}

@if (isDropAllOfferPopupOpen()) {
  <app-drop-all-confirm
    [itemId]="selectedOfferItemId()"
    [itemType]="selectedOfferItemType()"
    (closed)="onCloseDropAllOffer()"
    (dropped)="onCloseDropAllOffer()" />
}

@if (isDeliverPopup()) {
  <app-order-action-popup
    #deliverPopup
    type="deliver"
    [loading]="delivering()"
    [expectedAmount]="expectedAmount()"
    [(amountCollected)]="deliverAmountCollected"
    [optionData]="optionData()"
    [label]="isArabic() ? 'تعليق' : 'Comment'"
    (submit)="onDeliverOrder(deliverPopup.comment(), deliverPopup.amountCollected())"
    [title]="isArabic() ? 'تسليم الطلب' : 'Deliver Order'"
    (closePopup)="onCloseDeliver()"
    [err]="errDeliver()"
    [description]="isArabic() ? 'هل أنت متأكد من تسليم الطلب؟' : 'Are you sure you want to confirm deliver this order?'"
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
}

@if (successDeliverNotification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم تسليم الطلب بنجاح.' : 'Order delivered successfully.'" />
}

@if (receiveReturnedProductsPopup()) {
  <app-order-action-popup
    #receiveReturnedProductsPopup
    [loading]="receivingReturnedProducts()"
    [optionData]="optionData()"
    label="تعليق"
    (submit)="onReceiveReturnedProductsOrder(receiveReturnedProductsPopup.comment())"
    [title]="isArabic() ? 'استلام المنتجات المرتجعة' : 'Receive Returned Products'"
    (closePopup)="onCancelReceiveReturnedProducts()"
    [err]="errReceivingReturnedProducts()"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من استلام المنتجات المرتجعة ؟'
        : 'Are you sure you want to receive returned products for this order ?'
    "
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'"
    [detailedLabel]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
    [optionOne]="isArabic() ? 'حدد السبب لرفض هذا الطلب' : 'select the reason for rejecting this order'" />
}
<!-- @if (isPartiallyDeliverPopup()) {
    <app-order-action-popup
      #undeliverPopup
      type="detailed"
      [loading]="undelivering()"
      [optionData]="optionData()"
      label="تعليق"
      (submit)="onUndeliverOrder(undeliverPopup.selectedReasonId(), undeliverPopup.comment())"
      [title]="isArabic() ? 'تسليم جزئي' : 'Partially Deliver Order'"
      (closePopup)="onClosePartiallyDeliver()"
      [err]="errorShip()"
      [description]="
        isArabic()
          ? 'هل أنت متأكد من التسليم الجزئي الطلب ؟'
          : 'Are you sure you want to partially deliver this order ?'
      "
      [submitBtnContent]="isArabic() ? 'تسليم جزئي' : 'Partially Deliver'"
      [detailedLabel]="isArabic() ? 'سبب التسليم الجزئي' : 'Partially Deliver Reason'"
      [optionOne]="
        isArabic() ? 'حدد السبب التسليم الجزئي لهذا الطلب' : 'select the reason for partially deliver this order'
      " />
  } -->
<!-- @if (isUndeliverPopup()) {
    <app-order-action-popup
      #undeliverPopup
      [loading]="undelivering()"
      [optionData]="undeliveredReasons()"
      type="detailed"
      [label]="isArabic() ? 'تعليق' : 'Comment'"
      (submit)="onUndeliverOrder(undeliverPopup.selectedReasonId(), undeliverPopup.comment())"
      [title]="isArabic() ? 'إلغاء التسليم' : 'Undeliver Order'"
      (closePopup)="onCloseUndeliver()"
      [err]="errorShip()"
      [description]="
        isArabic() ? 'هل أنت متأكد من إلغاء تسليم الطلب ؟' : 'Are you sure you want to undeliver this order ?'
      "
      [submitBtnContent]="isArabic() ? 'إلغاء التسليم' : 'Undeliver'"
      [detailedLabel]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
      [optionOne]="isArabic() ? 'حدد السبب لرفض هذا الطلب' : 'select the reason for rejecting this order'" />
  } -->
<!-- <div *hasScope="SCOPES.ORDERS.UNDELIVER" > -->
@if (isUndeliverPopup()) {
  <app-undeliver-popup
    [orderId]="orderId()"
    [isArabic]="isArabic()"
    [isOpen]="isUndeliverPopup()"
    (close)="onCloseUndeliver()"
    (success)="loadOrderData(orderId()!)" />
}
<!-- </div> -->
@if (successNotification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم تسجيل الطلب كغير مُسلم بنجاح.' : 'Order has been marked as undelivered successfully.'" />
}
@if (isCancelPopup()) {
  <app-order-action-popup
    #cancelPopup
    type="detailed"
    [loading]="cancelling()"
    [optionData]="cancellationReasons()"
    [otherReasonId]="otherCancellationReasonId()"
    (submit)="onCancelOrder($event)"
    [title]="isArabic() ? 'إلغاء الطلب' : 'Cancel Order'"
    [showOtherReason]="true"
    (closePopup)="onCloseCancel()"
    [err]="cancelError()"
    [description]="isArabic() ? 'هل أنت متأكد من إلغاء هذا الطلب؟' : 'Are you sure you want to cancel this order?'"
    [submitBtnContent]="isArabic() ? 'تأكيد الإلغاء' : 'Confirm Cancellation'"
    [detailedLabel]="isArabic() ? 'سبب الإلغاء' : 'Cancellation Reason'"
    [optionOne]="isArabic() ? 'اختر سبباً للإلغاء' : 'Select a cancellation reason'"
    [label]="isArabic() ? 'ملاحظات' : 'Notes'" />
}
@if (successNotification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تمت طباعة الطلب بنجاح.' : 'Order printed successfully.'" />
}

@if (cancelSuccess()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم إلغاء الطلب بنجاح.' : 'Order has been cancelled successfully.'" />
}
